import React from 'react';

import './index.css';

const MainView = ({children}) => {

  return (
    <div className="main__view">
      {children}
    </div>
  );
}

export default MainView;